<!--
  ~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
  -->

<ngf-select-input [placeholder]="select.placeholder"
                  [hasError]="select.hasError"
                  [hasShadow]="select.hasShadow"
                  [displayValue]="value() | displayValue: select.displayWith: select.nullAsValue"
                  [isOpen]="select.optionsOverlay.isOpen"
                  [prefixIcon]="select.prefixIcon"
                  [disabled]="select.disabled || select.isReadonly"
                  [showOverflowTooltip]="showOverflowTooltip()"
                  [ariaLabel]="ariaLabel()"
                  [ariaLabelledby]="ariaLabelledby()"
                  [ariaDescribedby]="ariaDescribedby()"
                  [showClear]="showClear()"
                  (clear)="handleClear()"
                  (focusLost)="handleBlur()"/>
